import { MapPin, NavigationArrow } from '@phosphor-icons/react';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { Callout } from '../components/Callout';
import { Reveal } from '../components/Reveal';
import { serviceAreaGroups } from '../content/site';

export function ServiceArea() {
  return (
    <>
      <section className="area-hero section-shell">
        <Breadcrumbs items={[{ label: 'Service Area' }]} />
        <div className="area-hero__grid">
          <Reveal><p className="section-kicker">Havelock and Eastern North Carolina</p><h1>Start with the property location.</h1><p>Travel, access, material delivery, site conditions, and project size all affect availability.</p></Reveal>
          <Reveal className="area-hero__map" delay={0.08}>
            <MapPin aria-hidden="true" size={42} weight="fill" />
            <strong>Home base</strong><span>Havelock, North Carolina</span>
            <small>Confirm availability for your address when you request an estimate.</small>
          </Reveal>
        </div>
      </section>

      <section className="area-groups section-pad section-shell">
        {serviceAreaGroups.map((group, index) => (
          <Reveal as="article" key={group.county} delay={Math.min(index * 0.07, 0.2)}>
            <div><NavigationArrow aria-hidden="true" size={24} weight="duotone" /><h2>{group.county}</h2></div>
            <p>{group.context}</p>
            <ul>{group.places.map((place) => <li key={place}>{place}</li>)}</ul>
          </Reveal>
        ))}
      </section>

      <section className="area-note section-pad section-shell">
        <Reveal><h2>Confirm the location before planning the work.</h2><p>A city may fall within the broader service region while a particular project does not fit the current route, access, material, or scheduling needs. Send the address for a direct answer.</p></Reveal>
      </section>
      <Callout title="Want to confirm your address?" text="Share the city or ZIP code with the project type, and we will confirm whether the location fits the current service range." />
    </>
  );
}
